import type { ExportDto } from '@octopus-do/octopus-api-client'
import { LoaderActions } from '@store/loaders'
import {
  NotificationType,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import { call, put, takeLeading } from 'redux-saga/effects'

import { downloadReportPdf } from '@/components/SitemapReport/pdf'
import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { NestClient } from '@/nest'
import { ReportExportActions } from './actions'

export function* exportReportPdf({
  payload: uuid,
}: ReturnType<typeof ReportExportActions.pdf>) {
  yield put(LoaderActions.set('report_export_pdf'))
  try {
    const data: ExportDto = yield call(NestClient.sitemapReport.export, uuid, {
      set: 'all',
    })
    yield call(downloadReportPdf, data)
    yield call(sendGtmEvent, GtmTriggerName.REPORT_EXPORT_PDF)
  } catch {
    yield put(
      notificationActionCreators.setNotification({
        type: NotificationType.SOMETHING_WENT_WRONG_ERROR,
      })
    )
  } finally {
    yield put(LoaderActions.unset('report_export_pdf'))
  }
}

export function* reportExportSaga() {
  // One download across all three menus, including while the PDF is rendering.
  yield takeLeading(ReportExportActions.pdf, exportReportPdf)
}
